import React, { useState, useEffect } from 'react'
import ResponseMsg from '../general/ResponseMsg';
import { useNavigate } from 'react-router-dom';


const AdminDashboard = () => {
  const navigate = useNavigate();
  const [response, setResponse] = useState(null);
  const [products, setProducts] = useState([]);
  const [visibleCount, setVisibleCount] = useState(30);
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [notify, setNotify] = useState('');
  const [selectedProduct, setSelectedProduct] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [formData, setFormData] = useState({
    productName: '',
    productUnit: '',
    barcode: '',
    hsnCode: '',
    category: '',
    mfgDate: '',
    expDate: '',
    // image: null,
    purchasePrice: '',
    originalPrice: '',
    sellPrice: '',
    sellPriceTax: '',
    tax: '',
    discountType: '',
    discountGiven: '',
    description: '',
    prescription: '',
    added_pres: '',
    composition: '',
    brand: '',
    stock: '',

  });

  const handleChange = (e) => {
    const { id, value } = e.target;
      setFormData({
        ...formData,
        [id]: value
      });
  };


      const fetchProducts = async () => {
      try {
        const response = await fetch('https://api.kcmstore.in/store/get-product');
        if (response.ok) {
          const data = await response.json();
const sortedProducts = data.sort((a, b) => b.id - a.id);          setProducts(sortedProducts);

        } else {
          console.error('Failed to fetch products');
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };


  useEffect(() => {

    fetchProducts();
  }, []);

  const handleDeleteDialog = (product) => {
    setShowDelete(true);
    setSelectedProduct(product);
  }

  const handleDelete = async (productId) => {
    try {
      const response = await fetch(`https://api.kcmstore.in/store/delete-product/${productId}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        setProducts((prevProducts) => prevProducts.filter((product) => product.id !== productId));
        setResponse('Product deleted successfully!');
        setTimeout(() => {
          setResponse('');
        }, 2000);
        setShowDelete(false);
      } else {
        setResponse('Unable to Delete product.');
        setTimeout(() => {
          setResponse('');
        }, 2000);  
      }
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };


  const handleEditDialog = (product) => {
    setShowEdit(true);
    setSelectedProduct(product);
    setFormData({
      productName: product.name || '',
      productUnit: product.unit || '',
      barcode: product.barcode || '',
      hsnCode: product.hsn_code || '',
      category: product.category || '',
      mfgDate: product.mfg || '',
      expDate: product.exp || '',
      // image: null,
      purchasePrice: product.purchase_price || '',
      originalPrice: product.org_price || '',
      sellPrice: product.sell_price || '',
      sellPriceTax: product.tax_type || 'with tax',
      tax: product.tax_amount || 'none',
      discountType: product.discount_type || '',
      discountGiven: product.discount_amount || '0',
      description: product.description || '',
      prescription: product.prescription || '',
      added_pres: product.added_pres || 'no',
          composition: product.composition || '',
    brand: product.brand || '',
    stock: product.stock || '',
    });
  };


  const handleUpdateProduct = async (e) => {
    e.preventDefault();
    try {

      const response = await fetch(`https://api.kcmstore.in/store/update-product/${selectedProduct.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const updatedProduct = await response.json();
        setResponse('Product updated successfully!');
          setShowEdit(false);
         setTimeout(() => {
          setResponse('');
        
        }, 1000);
        fetchProducts();
      } else {
        setResponse('Unable to update product.');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      console.error('Error updating product:', error);
    }
  };

  const sendUserNotification = async (notify) => {
    try {

      const response = await fetch(`https://api.kcmstore.in/store/notify-users`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ notify: notify }),
      });

      if (response.ok) {
        setResponse('Notification sent successfully!');
         setTimeout(() => {
          setResponse('');
        }, 1000);
      } else {
        setResponse('Unable to sent Notification.');
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      console.error('Error updating product:', error);
    }
  };


const filteredProducts = products.filter(product => {
  const query = searchQuery.toLowerCase();

  const name = product.name?.toLowerCase() || "";
  const brand = product.brand?.toLowerCase() || "";
  const category = product.category?.toLowerCase() || "";
  const composition = product.composition?.toLowerCase() || "";

  return (
    name.includes(query) ||
    brand.includes(query) ||
    category.includes(query) ||
    composition.includes(query)
  );
});



useEffect(() => {
  setVisibleCount(30);
}, [searchQuery]);

useEffect(() => {
  const interval = setInterval(() => {
    setVisibleCount((prev) => {
      if (prev >= filteredProducts.length) {
        clearInterval(interval);
        return prev;
      }
      return prev + 30;
    });
  }, 3000);

  return () => clearInterval(interval);
}, [filteredProducts]);


  return (
    <>
      <section className='py-4 bg-light'>
        <div className='px-4'>

          <div className='row'>


            <div className='col-lg-9 col-12 my-2'>

              <div className='d-lg-flex d-md-flex d-block justify-content-between'>
                <div className='d-flex'>
                  <p className='sec-heading'>Dashboard</p>
                  <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Admin</span>
                </div>

                <div className="text-start mb-4">
                  <input
                    type="text"
                    className="form-input w-100 rounded border-0"
                    placeholder="🎯 Search by Name"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
              </div>

              <div className='row bg-white rounded-4 px-lg-2 py-3 justify-content-start'>
                {filteredProducts.length > 0 ? (
                  filteredProducts.slice(0, visibleCount).map((product) => {

                    const firstImage = product.image ? product.image.split(',')[0] : '';

                    return (
                    <div key={product.id} className='col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 my-2 px-2'>
                      <div className='featured-area h-100 align-content-center'>

                        <div className='featured-btn-area animate__animated animate__fadeInLeft animate__fast'>
                          <button className='featured-btn' onClick={() => handleEditDialog(product)}><i class="fa-solid fa-pen-to-square"></i></button><br />
                          <button className='featured-btn' onClick={() => handleDeleteDialog(product)}><i class="fa-solid fa-trash-can"></i></button></div>

                        <img src={`https://api.kcmstore.in/sUploads/${firstImage}`} className='img-fluid' alt={product.name || 'Product'} />
                        <p className='featured-category'>{product.unit || 'Unit'}</p>
                        <p className='featured-name cursor-pointer' onClick={() => navigate(`/product-details/${product.name}`, { state: { product } })}>{product.name}</p>
                        <p className='featured-price d-flex justify-content-center'>₹ {product.sell_price}{product.discount_amount > 0 && (
                          <p className='text-start ps-2 text-muted fw-semibold fs-6 my-0'>
                            {product.discount_amount}{product.discount_type === 'percent' ? '%' : '₹'}  Off
                          </p>
                        )}</p>
                      </div>
                    </div>
                    );
                  })                    
                ) : (
                  <p>No products available</p>
                )}
              </div>

            </div>
            {/* left section ends */}


            <div className='col-lg-3 col-12 my-2 px-lg-3 px-md-3 px-0'>
              <div className='bg-white px-3 py-3 rounded-3'>
                <p className='fw-semibold'>General Notification</p>

        <textarea
          className='form-control mb-3'
          rows="2"
          placeholder="Mention notification text here..."
          value={notify}
          onChange={(e) => setNotify(e.target.value)}
        />

        <button className='sort-btn text-end' onClick={() => sendUserNotification(notify)}>Notify <i class="fa-solid fa-paper-plane"></i></button>

</div>
              
              {/* bottom banner section */}
              <section className='bottom-banner-bg my-3 rounded-4'>
                <div className='container py-4'>

                  <p className='fw-bold'>Doctor's Recommended Range</p>
                  <button className='banner-btn para-text animate__animated animate__pulse animate__infinite' onClick={() => navigate('/add-product')}>Add Product</button>

                </div>
              </section>
              {/* bottom banner section ends */}

              <div className='bg-white px-3 py-3 rounded-3'>
                <p className='fw-semibold'>Recently Added</p>

                {products.length > 0 ? (
                  products.slice(0, 4).map((product) => (
                    <>
                      <hr className='my-0' />
                      <div key={product.id} className='d-flex my-2'>

                        <img src={`https://api.kcmstore.in/sUploads/${product.image.split(',')[0]}`} className='img-fluid col-3 me-2' alt={product.name || 'Product'} />

                        <div className='align-content-center'>
                          <p className='featured-name cursor-pointer my-0' onClick={() => navigate(`/product-details/${product.name}`, { state: { product } })}>{product.name}</p>
                          <p className='featured-category para-text my-0'>{product.unit || 'Unit'} | Stock: {product.stock}</p></div>
                      </div>
                    </>
                  ))
                ) : (
                  <p>No products available</p>
                )}

              </div>
              {/* recently added ends */}


            </div>
            {/* right section ends */}

          </div>
          {/* row ends */}

        </div>
      </section>

      {showDelete && (
        <>
          <section className='delete-dialog px-3' onClick={() => setShowDelete(false)}>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>
              <p className='featured-category'>Do you want to delete this product?</p>
              <p className='featured-name my-4'>{selectedProduct.name}</p>
              <button className='success-btn' onClick={() => handleDelete(selectedProduct.id)}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowDelete(false)}>No</button>
            </div>
          </section>
        </>
      )}

      {showEdit && (
        <section className='delete-dialog px-3 py-5'>
          <div className='bg-white col-md-10 mx-auto px-3 py-4 rounded-4'>
          <p className='sec-heading fs-5 text-start'>Edit This Product</p>

            <form className="row g-3 text-start py-2" onSubmit={handleUpdateProduct}>
              {/* Product Name */}
              <div className="col-md-3">
                <label htmlFor="productName" className="form-label fw-semibold">Product Name</label>
                <input
                  type="text"
                  className="form-input"
                  id="productName"
                  value={formData.productName}
                  onChange={handleChange}
                />
              </div>

              {/* Product Unit */}
              <div className="col-md-3">
                <label htmlFor="productUnit" className="form-label fw-semibold">Product Unit</label>
                <input
                  type="text"
                  className="form-input"
                  id="productUnit"
                  placeholder='Tablets, Capsules, Gel, Supplements...'
                  value={formData.productUnit}
                  onChange={handleChange}
                />
              </div>

              {/* Barcode */}
              <div className="col-md-3">
                <label htmlFor="barcode" className="form-label fw-semibold">Barcode</label>
                <input
                  type="text"
                  className="form-input"
                  id="barcode"
                  value={formData.barcode}
                  onChange={handleChange}
                />
              </div>

              {/* HSN Code */}
              <div className="col-md-3">
                <label htmlFor="hsnCode" className="form-label fw-semibold">HSN Code</label>
                <input
                  type="text"
                  className="form-input"
                  id="hsnCode"
                  value={formData.hsnCode}
                  onChange={handleChange}
                />
              </div>

              {/* Category */}
              <div className="col-md-3">
                <label htmlFor="category" className="form-label fw-semibold">Category</label>
                <input
                  type="text"
                  className="form-input"
                  id="category"
                  placeholder='Fever, Cold, Headache ...'
                  value={formData.category}
                  onChange={handleChange}
                />
              </div>

              {/* Brand */}
              <div className="col-md-3">
                <label htmlFor="brand" className="form-label fw-semibold">Brand</label>
                <input
                  type="text"
                  className="form-input"
                  id="brand"
                  placeholder='Fever, Cold, Headache ...'
                  value={formData.brand}
                  onChange={handleChange}
                />
              </div>



              {/* Manufacturing Date */}
              <div className="col-md-3">
                <label htmlFor="mfgDate" className="form-label fw-semibold">Mfg Date</label>
                <input
                  type="date"
                  className="form-input"
                  id="mfgDate"
                  value={formData.mfgDate}
                  onChange={handleChange}
                />
              </div>

              {/* Expiry Date */}
              <div className="col-md-3">
                <label htmlFor="expDate" className="form-label fw-semibold">Exp Date</label>
                <input
                  type="date"
                  className="form-input"
                  id="expDate"
                  value={formData.expDate}
                  onChange={handleChange}
                />
              </div>

{/* Stock */}
              <div className="col-md-3">
                <label htmlFor="stock" className="form-label fw-semibold">Stock</label>
                <input
                  type="text"
                  className="form-input"
                  id="stock"
                  placeholder=''
                  value={formData.stock}
                  onChange={handleChange}
                />
              </div>

              {/* Purchase Price */}
              <div className="col-md-3">
                <label htmlFor="purchasePrice" className="form-label fw-semibold">Purchase Price</label>
                <input
                  type="number"
                  className="form-input"
                  id="purchasePrice"
                  value={formData.purchasePrice}
                  onChange={handleChange}
                />
              </div>

              {/* Original Price */}
              <div className="col-md-3">
                <label htmlFor="originalPrice" className="form-label fw-semibold">Original MRP</label>
                <input
                  type="number"
                  className="form-input"
                  id="originalPrice"
                  value={formData.originalPrice}
                  onChange={handleChange}
                />
              </div>

              {/* Sell Price */}
              <div className="col-md-3">
                <label htmlFor="sellPrice" className="form-label fw-semibold">Sell Price</label>
                <input
                  type="number"
                  className="form-input"
                  id="sellPrice"
                  value={formData.sellPrice}
                  onChange={handleChange}
                />
              </div>

              {/* Sell Price Tax */}
              <div className="col-md-3">
                <label className="form-label fw-semibold" htmlFor="sellPriceTax">Sell Price Tax</label>
                <select
                  className="form-input"
                  id="sellPriceTax"
                  value={formData.sellPriceTax}
                  onChange={handleChange}
                >
                  <option value="with tax" selected>With Tax</option>
                  <option value="without tax">Without Tax</option>
                </select>
              </div>

              {/* Tax Applicable */}
              <div className="col-md-3">
                <label className="form-label fw-semibold" htmlFor="tax">Tax Applicable</label>
                <select
                  className="form-input"
                  id="tax"
                  value={formData.tax}
                  onChange={handleChange}
                  selected
                >
                  <option value="none">None</option>
                  <option value="GST 0">GST 0%</option>
                  <option value="IGST 0">IGST 0%</option>
                  <option value="GST 0.25">GST 0.25%</option>
                  <option value="IGST 0.25">IGST 0.25%</option>
                  <option value="GST 3">GST 3%</option>
                  <option value="IGST 3">IGST 3%</option>
                  <option value="GST 5">GST 5%</option>
                  <option value="IGST 5">IGST 5%</option>
                  <option value="GST 12">GST 12%</option>
                  <option value="IGST 12">IGST 12%</option>
                  <option value="GST 18">GST 18%</option>
                  <option value="IGST 18">IGST 18%</option>
                  <option value="GST 28">GST 28%</option>
                  <option value="IGST 28">IGST 28%</option>
                </select>
              </div>

              {/* Discount Type */}
              <div className="col-md-3">
                <label className="form-label fw-semibold" htmlFor="discountType">Sell Price Discount</label>
                <select
                  className="form-input"
                  id="discountType"
                  value={formData.discountType}
                  onChange={handleChange}
                  selected
                >
                  <option value="">Choose...</option>
                  <option value="percent">Percent %</option>
                  <option value="amount">Amount ₹</option>
                </select>
              </div>

              {/* Discount Given */}
              <div className="col-md-3">
                <label className="form-label fw-semibold" htmlFor="discountGiven">Discount Given</label>
                <input
                  type="number"
                  className="form-input"
                  id="discountGiven"
                  value={formData.discountGiven}
                  onChange={handleChange}
                />
              </div>

              {/* Description */}
              <div className="col-12">
                <label htmlFor="description" className="form-label fw-semibold">Description</label>
                <textarea
                  className="form-input"
                  style={{ height: '12em' }}
                  id="description"
                  value={formData.description}
                  onChange={handleChange}
                />
              </div>

              {/* Prescription */}
                            <div className="col-md-4">
                <label htmlFor="composition" className="form-label fw-semibold">Composition</label>
                <textarea
                  className="form-input"
                  style={{ height: '10em' }}
                  id="composition"
                  value={formData.composition}
                  onChange={handleChange}
                />
              </div>


              <div className="col-md-4">
                <label htmlFor="prescription" className="form-label fw-semibold">Prescription</label>
                <textarea
                  className="form-input"
                  style={{ height: '10em' }}
                  id="prescription"
                  value={formData.prescription}
                  onChange={handleChange}
                />
              </div>


<div className="col-md-4 add-label-area">
  <input
    type="checkbox"
    id="added_pres"
    checked={formData.added_pres === 'yes'}
    onChange={(e) =>
      setFormData({
        ...formData,
        added_pres: e.target.checked ? 'yes' : 'no',
      })
    }
  />
  <label htmlFor="added_pres" className="form-label fw-semibold">
    &nbsp;&nbsp;Requires Medical Prescription
  </label><br />
  <small className="form-text text-muted">
   Tick this if the medicine requires a valid medical prescription from the buyer.
  </small>
</div>

              {/* Submit Button */}
              <div className="col-12 text-end">
                <button className='danger-btn' onClick={() => setShowEdit(false)}>Cancel</button>&nbsp;&nbsp;
                <button type="submit" className="success-btn">Update</button>
              </div>
            </form>

          </div>
        </section>
      )}


      {response && <ResponseMsg message={response} />}
    </>
  )
}


export default AdminDashboard
